import type { PaymentStatus } from "./types"
import _ from "lodash"
import * as strings from "./strings"
import React, { Component } from "react"
import { connect } from "react-redux"
import * as actions from "./actions"
import { bindActionCreators } from "redux"
import download from "downloadjs"
import { toastr } from "react-redux-toastr"

export const formatPercent = ( value, precision = 2 ) => {
  if ( typeof value === "string" ) {
    return value + " %"
  } else if ( typeof value === "number" ) {
    return value.toFixed( precision ) + " %"
  } else {
    return "--"
  }
}


export const formatCurrency = ( amount: number | string ): string => {
  let amountStr

  if ( typeof amount === "number" ) {
    amountStr = amount.toFixed( 2 )
  } else if ( _.isUndefined( amount ) || _.isNull( amount ) ) {
    amountStr = "--"
  } else {
    amountStr = amount
  }

  return amountStr + " EUR"
}

export const formatPaymentStatus = ( status: PaymentStatus ) => status === "Waiting" ? "Pendente" : "Pago"

const padZero = ( number ) => {
  return number < 10 ? "0" + number.toString() : number.toString()
}

export const formatDateTime = ( inDate: string | Date ): string => {
  if ( inDate === null || inDate === undefined ) {
    return inDate
  }

  const date = new Date( inDate )
  const fullDate = formatDate( date )
  const hours = padZero( date.getHours() )
  const minutes = padZero( date.getMinutes() )
  return fullDate + " " + hours + ":" + minutes
}

export const formatDate = ( inDate: string | Date, separator: string = "."): string => {
  if ( inDate !== null && inDate !== undefined ) {
    const date = new Date( inDate )
    return [
      padZero( date.getUTCDate() ),
      padZero( date.getUTCMonth() + 1 ),
      date.getUTCFullYear(),
    ].join(separator)
  } else {
    return inDate
  }
}

export const formatDateToShortDate = date => formatDate(date, "-")
  .split("-")
  .reverse()
  .join("-")

export const getCurrentInterestTax = ( rates ) => {
  const now = new Date()
  return rates.find( rate => {
    return ( new Date ( rate.startDate ) <= now && rate.endDate === null ) ||
      new Date ( rate.startDate ) <= now && new Date( rate.endDate ) >= now
  } )
}

/*
 * TODO: Remove this and prefer to use transaltions in src/strings.jsx
 */
export const translationFunction = ( wordTotranslate ) => {
  const translationTable = {
    ...strings.PaymentAgreementStatusTranslation,
    "CC": "Cartão de cidadão",
    "BI": "Bilhete de identidade",
    "Passport": "Passaporte",
    "DriversLicense": "Carta de condução",
    "ResidenceTitle": "Título de Residência",
    "--": "--",
  }
  return translationTable[ wordTotranslate ]
}

const pickAllDebts = ( results ) => {
  return results.data.map( item => item.idDebt )
}

export const handlePickedBoxes = ( element, selectedDebts, results ) => {
  let pickedDebts = _.cloneDeep( selectedDebts )
  if ( element === "ALL" ) {
    const pickAll = selectedDebts.length !== results.data.length
    pickedDebts = pickAll ? pickAllDebts( results ) : []
  } else {
    if ( _.indexOf( pickedDebts, element ) < 0 ) {
      pickedDebts = [ ...pickedDebts, element ]
    } else {
      _.remove( pickedDebts, pickedDebt => pickedDebt === element )
    }
  }
  return pickedDebts
}

// Joins both arrays, but gives preference to objects that have the same `property`
// but are on the `newArray`
//
// TODO: I think the whole map thing is unecessary if we provide
// `newArray` as a first argument to `_.unionBy`
export const listReplace = ( oldArray, newArray, property = "id" ) =>
  _.unionBy( oldArray, newArray, property ).map( oldObject => {

    // Search for an object in the newArray with the same property as the old one
    const newObject = newArray.find( newObject => oldObject[ property ] === newObject[ property ] )

    // Returns a new object if we have it
    return newObject || oldObject
  } )

export const removeNulls = ( obj ) => _.omitBy( obj, _.isNil )

export const cleanupOption = ( option, extraFields = [] ) => option && _.omit( option, [
  ...extraFields,
  "id",
  "idPrelitigation",
  "idLitigation",
  "idExecution",
] )


export const removeUndefined = obj => _.isArray( obj )
  ? _.reject( obj, _.isUndefined )
  : _.omitBy( obj, _.isUndefined )


// TODO?:
// Export separate functions or change this to get model specific actions. Ex.: withActions( "Project", Component )

// Calling withActions(Component) will allow 'Component' to access redux actions through the .props variable,
// which are automatically dispatched (no need to call store.dispatch)
export const withActions = ToWrap => {
  const className = `${ ToWrap.name }WithActions`

  // eslint-disable-next-line react/display-name
  const WrappedComponent = class extends Component {
    render () {
      return <ToWrap {...this.props} />
    }
  }

  Object.defineProperty( WrappedComponent, "name", { value: className } )

  return connect( null, dispatch => ( {
    actions: bindActionCreators( actions, dispatch ),
  } ) )( WrappedComponent )
}


export const downloadFile = async ( token, command, args, fileName ) => {
  return await actions.unparsedTokenCommand( token, {
    command,
    args: args,
  } )
    .then( response => {
      if ( response.status !== 200 ) {
        throw new Error( "Error downloading file" )
      }

      const contentType = response.headers.get( "Content-type" )
      return response.blob()
        .then( blob => ( {
          contentType,
          blob,
        } ) )
    } )
    .then( file => download( file.blob, fileName, file.contentType ) )
    .catch( () => toastr.error( strings.errorMessages.downloadError ) )
}




// WEBPACK FOOTER //
// ./src/utils.jsx